const isCollectionLoading = collection => {
  return (
    collection.loadingStatus === undefined ||
    collection.loadingStatus === 'loading'
  )
}

export default isCollectionLoading
